import styled from "styled-components";

export const Input = styled.input`
    height: 44px;
    border-width: 2px;
    border-style: solid;
    border-color: ${(props) => props.theme.color.primary.light};
    width: 100%;
    font-family: ${(props) => props.theme.font.t["font-family"]};
    font-style: ${(props) => props.theme.font.t["font-style"]};
    font-weight: ${(props) => props.theme.font.t["font-weight"]};
    font-size: ${(props) => props.theme.font.t["font-size"]};
    color: ${(props) => props.theme.color.neutral.base};
    padding-left: ${(props) => props.theme.input.padding};
    box-sizing: border-box;

    &:focus {
        border-color: ${(props) => props.theme.color.neutral.base};
    }

    &:disabled {
        background-color: #eee;
        color: ${(p) => p.theme.color.neutral.base};
    }
`;

export default Input;
